import {
  Component,
  effect,
  ElementRef,
  inject,
  ViewChild,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { uploadData } from 'aws-amplify/storage';
import { v4 as uuidv4 } from 'uuid';
import { CommonModule } from '@angular/common';
import { CompanyService } from 'src/app/services/company';
import { LocaleService } from 'src/app/services/locale';
import { DropdownComponent } from '../../shared/dropdown';
import { InputComponent } from '../../shared/input';
import { UploadComponent } from '../../icons/upload';
import { ButtonComponent } from '../../shared/button';
import { SaveComponent } from '../../icons/save';
import { CountryPickerComponent } from '../../shared/country-picker';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-company',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    DropdownComponent,
    InputComponent,
    UploadComponent,
    ButtonComponent,
    SaveComponent,
    CountryPickerComponent,
  ],
  template: `
    <div class="text-base sm:text-lg lg:text-xl futura text-[#043B22]">
      {{ locale.form_company_registration.heading }}
    </div>
    <div
      class="text-xs sm:text-sm text-[#616161] mt-2.5 sm:mt-3 w-full max-w-4xl 2xl:max-w-6xl leading-relaxed"
    >
      <p>{{ locale.form_company_registration.subheading }}</p>
    </div>
    <form [formGroup]="form" (submit)="submit()">
      <div class="mt-8 grid grid-cols-2 gap-6">
        <app-dropdown
          [options]="[
            {
              label: locale.form_company_registration.company_type_option1,
              value: locale.form_company_registration.company_type_option1,
            },
            {
              label: locale.form_company_registration.company_type_option2,
              value: locale.form_company_registration.company_type_option2,
            },
          ]"
          label="{{ locale.form_company_registration.lbl_company_type }} ({{
            locale.common.required
          }})"
          placeholder="{{
            locale.form_company_registration.placeholder_company_type
          }}"
          [control]="form.controls['companyType']"
        ></app-dropdown>
        <app-dropdown
          [options]="[
            {
              label: locale.common.business_sector_option_commerce,
              value: locale.common.business_sector_option_commerce,
            },
            {
              label: locale.common.business_sector_option_services,
              value: locale.common.business_sector_option_services,
            },
            {
              label: locale.common.business_sector_option_industry,
              value: locale.common.business_sector_option_industry,
            },
            {
              label: locale.common.business_sector_option_manufacturing,
              value: locale.common.business_sector_option_manufacturing,
            },
            {
              label: locale.common.business_sector_option_craft_artisanal,
              value: locale.common.business_sector_option_craft_artisanal,
            },
            {
              label: locale.common.business_sector_option_agriculture,
              value: locale.common.business_sector_option_agriculture,
            },
            {
              label: locale.common.business_sector_option_construction,
              value: locale.common.business_sector_option_construction,
            },
            {
              label: locale.common.business_sector_option_transport_logistics,
              value: locale.common.business_sector_option_transport_logistics,
            },
            {
              label: locale.common.business_sector_option_energy_utilities,
              value: locale.common.business_sector_option_energy_utilities,
            },
            {
              label: locale.common.business_sector_option_ict_software,
              value: locale.common.business_sector_option_ict_software,
            },
            {
              label: locale.common.business_sector_option_finance_insurance,
              value: locale.common.business_sector_option_finance_insurance,
            },
            {
              label:
                locale.common
                  .business_sector_option_healthcare_personal_services,
              value:
                locale.common
                  .business_sector_option_healthcare_personal_services,
            },
            {
              label: locale.common.business_sector_option_education_training,
              value: locale.common.business_sector_option_education_training,
            },
            {
              label: locale.common.business_sector_option_tourism_hospitality,
              value: locale.common.business_sector_option_tourism_hospitality,
            },
            {
              label: locale.common.business_sector_option_real_estate,
              value: locale.common.business_sector_option_real_estate,
            },
            {
              label: locale.common.business_sector_option_public_administration,
              value: locale.common.business_sector_option_public_administration,
            },
            {
              label: locale.common.business_sector_option_other,
              value: locale.common.business_sector_option_other,
            },
          ]"
          label="{{ locale.common.lbl_business_sector }}"
          placeholder="{{
            locale.form_company_registration.placeholder_business_sector
          }}"
          [control]="form.controls['businessSector']"
        ></app-dropdown>
        <app-input
          label="{{ locale.common.lbl_vat_number }} ({{
            locale.common.required
          }})"
          [control]="form.controls['vatNumber']"
          placeholder="{{ locale.common.placeholder_enter_value }}"
        ></app-input>
        <app-input
          label="{{ locale.common.lbl_company_name }} ({{
            locale.common.required
          }})"
          [control]="form.controls['companyName']"
          placeholder="{{ locale.common.placeholder_enter_value }}"
        ></app-input>
        <app-input
          label="{{ locale.common.lbl_street }} ({{
            locale.common.recommended
          }})"
          [control]="form.controls['street']"
          placeholder="{{ locale.common.placeholder_enter_value }}"
        ></app-input>
        <app-input
          label="{{ locale.common.lbl_city }} ({{ locale.common.recommended }})"
          [control]="form.controls['city']"
          placeholder="{{ locale.common.placeholder_enter_value }}"
        ></app-input>
        <app-input
          label="{{ locale.common.lbl_province }} ({{
            locale.common.recommended
          }})"
          [control]="form.controls['provinceField']"
          placeholder="{{ locale.common.placeholder_enter_value }}"
        ></app-input>
        <app-input
          label="{{ locale.common.lbl_postal_code }} ({{
            locale.common.recommended
          }})"
          [control]="form.controls['postalCode']"
          placeholder="{{ locale.common.placeholder_enter_value }}"
        ></app-input>
        <!-- <app-input
          label="{{ locale.common.country }} ({{ locale.common.recommended }})"
          [control]="form.controls['country']"
          placeholder="{{ locale.common.placeholder_enter_value }}"
        ></app-input> -->
        <div class="flex flex-col gap-0.5">
          <label class=" text-[#616161] text-[12px]">
            {{ locale.common.country }}
            ({{ locale.common.recommended }})
          </label>
          <app-country-picker
            [control]="form.controls['country']"
          ></app-country-picker>
        </div>
        <app-input
          label="{{ locale.form_company_registration.lbl_contact_phone }}"
          type="number"
          [control]="form.controls['phone']"
          placeholder="{{ locale.common.placeholder_enter_value }}"
        ></app-input>
        <app-input
          label="{{ locale.form_company_registration.lbl_contact_email }}"
          type="email"
          [control]="form.controls['email']"
          placeholder="{{ locale.common.placeholder_enter_value }}"
        ></app-input>
        <div class="text-[#616161]">
          {{ locale.form_company_registration.lbl_company_logo }}
          <div class="flex gap-8 mt-2 align-middle items-center">
            <input
              accept=".jpg, .jpeg, .png"
              #fileInput
              type="file"
              class="hidden"
              (change)="selectFile($event)"
            />
            <div
              [ngStyle]="{
                backgroundImage: imageUrl
                  ? imageUrl
                  : 'url(/images/welcome.png)',
              }"
              class="h-24 w-24 bg-center bg-cover rounded-full"
            ></div>
            <div
              (click)="pickFile()"
              class="px-4 py-2 h-fit w-fit border border-[#043b22]/80 futura flex gap-3 align-middle items-center justify-center rounded-lg cursor-pointer"
            >
              <app-upload></app-upload>
              {{ locale.form_company_registration.button_upload }}
            </div>
          </div>
        </div>
      </div>
      <hr class="my-8 text-gray-300" />
      <app-button
        *ngIf="!company"
        [disabled]="form.invalid"
        class="my-8 w-44 font-bold flex"
        text="{{ locale.form_company_registration.button_add_now }}"
      >
      </app-button>
      <div class="my-8 w-fit">
        <app-button
          *ngIf="company"
          [disabled]="form.invalid"
          text="{{ locale.profile.button_save }}"
        >
          <app-save></app-save>
        </app-button>
      </div>
    </form>
  `,
})
export class CompanyComponent {
  @ViewChild('fileInput') fileInput!: ElementRef;

  private spinner = inject(NgxSpinnerService);
  private localeService = inject(LocaleService);
  private companyService = inject(CompanyService);

  locale = this.localeService.locale();
  company = this.companyService.company();

  form = new FormGroup({
    id: new FormControl(uuidv4()),
    companyType: new FormControl('', Validators.required),
    businessSector: new FormControl(''),
    vatNumber: new FormControl('', Validators.required),
    companyName: new FormControl('', Validators.required),
    street: new FormControl(''),
    city: new FormControl(''),
    provinceField: new FormControl(''),
    postalCode: new FormControl(''),
    country: new FormControl(''),
    phone: new FormControl('', [
      Validators.required,
      Validators.minLength(10),
      Validators.maxLength(10),
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/),
    ]),
    isFavorite: new FormControl<boolean>(false),
    logo: new FormControl(''),
  });

  imageUrl: string | null = null;
  selectedFile: File | null = null;

  constructor() {
    effect(() => {
      this.locale = this.localeService.locale();
      this.company = this.companyService.company();
      if (this.companyService.company()) {
        const company = this.companyService.company();
        // Parse structured address JSON if stored, otherwise treat as legacy plain string
        const rawAddress = company.address ?? '';
        let street = '',
          city = '',
          provinceField = '',
          postalCode = '';
        try {
          const parsed = JSON.parse(rawAddress);
          if (parsed && typeof parsed === 'object') {
            street = parsed.street || '';
            city = parsed.city || '';
            provinceField = parsed.province || '';
            postalCode = parsed.postalCode || '';
          }
        } catch {
          // Legacy plain-string address: use as street fallback
          street = rawAddress;
        }
        this.form.setValue({
          id: company.id ?? '',
          companyType: company.companyType ?? '',
          businessSector: company.businessSector ?? '',
          vatNumber: company.vatNumber ?? '',
          companyName: company.companyName ?? '',
          street,
          city,
          provinceField,
          postalCode,
          country: company.country ?? '',
          phone: company.contactPhone ?? '',
          email: company.contactEmail ?? '',
          isFavorite: company.isFavorite ?? false,
          logo: company.originalCompanyLogo ?? '',
        });
        if (company.companyLogo?.length > 0) {
          this.imageUrl = "url('" + company.companyLogo + "')";
        }
      } else {
        this.form.reset();
        this.imageUrl = null;
        this.form.controls.id.setValue(uuidv4());
        this.form.controls.companyType.setValue('');
        this.form.controls.businessSector.setValue('');
      }
    });
  }

  submit = async () => {
    try {
      this.spinner.show();
      await this.uploadLogo();
      if (!this.company) {
        await this.companyService.createCompany(this.form);
      } else {
        await this.companyService.updateCompany(this.form);
      }
    } catch (error) {}
  };

  pickFile(): void {
    this.fileInput.nativeElement.click();
  }

  selectFile(event: any): void {
    const file = event.target.files[0];

    if (file) {
      this.selectedFile = file;
      const reader = new FileReader();

      reader.onload = async (e: any) => {
        this.imageUrl = "url('" + e.target.result + "')";
      };

      reader.readAsDataURL(file);
    }
  }

  async uploadLogo(): Promise<void> {
    try {
      if (!this.selectedFile) return;

      const fileName = `company-logos/${Date.now()}_${this.selectedFile.name}`;

      await uploadData({
        path: fileName,
        data: this.selectedFile,
      }).result;

      // Store permanent public S3 URL instead of just the path
      const permanentUrl = `https://${environment.s3.bucket}.s3.${environment.s3.region}.amazonaws.com/${fileName}`;

      this.form.controls['logo'].setValue(permanentUrl);
    } catch (error) {}
  }
}
